<template>
	<v-form ref='form' @submit.prevent="$emit('submit')">
		<v-row>
			<v-col>
				<h4>General information</h4>
				<validation-provider
					v-slot='{ errors }'
					rules='required'
					slim
					name='name'
				>
					<v-text-field
						v-model='sortition.name'
						label='Name'
						name='name'
						:error-messages='errors'
						type='text'
					>
					</v-text-field>
				</validation-provider>
				<validation-provider
					v-slot='{ errors }'
					rules='required'
					slim
					name='abbreviation'
				>
					<v-text-field
						v-model='sortition.abbreviation'
						label='Abbreviation'
						name='abbreviation'
						:error-messages='errors'
						type='text'
					>
					</v-text-field>
				</validation-provider>
				<validation-provider
					v-slot='{ errors }'
					v-if='sortition.resultFields.includes(ResultField.PickTwo)'
					rules=''
					slim
					name='pickTwoEquivalentSortition'
				>
					<v-text-field
						v-if='sortition.resultFields.includes(ResultField.PickTwo)'
						v-model='sortition.pickTwoEquivalentSortition'
						label='Pick two equivalent sortition'
						name='pickTwoEquivalentSortition'
						:error-messages='errors'
						type='text'
					/>
				</validation-provider>
				<validation-provider
					v-slot='{ errors }'
					rules=''
					slim
					name='equivalentSortition'
				>
					<v-text-field
						v-model='sortition.equivalentSortition'
						label='Equivalent sortition'
						name='equivalentSortition'
						:error-messages='errors'
						type='text'
					/>
				</validation-provider>
				<v-spacer></v-spacer>
				<h4>Closing times</h4>
				<sortition-weekday-schedule-row
					v-for='(schedule, index) in sortition.schedules'
					:key='`weekday-${schedule.weekday}`'
					v-model='sortition.schedules[index]'
					:weekday='weekdayIdToWeekdayMap[schedule.weekday]'
					:index='index'
					@copy='onScheduleCopy'
				>
				</sortition-weekday-schedule-row>
			</v-col>
			<v-col>
				<validation-provider
					v-slot='{ errors }'
					slim
					name='isPeriodic'>
					<v-checkbox
						name='isPeriodic'
						:error-messages='errors'
						dense
						label='Periodic'
						v-model='sortition.isPeriodic' />
				</validation-provider>
				<validation-provider
					v-if='sortition.isPeriodic'
					v-slot='{ errors }'
					rules='required'
					slim
					name='periodicSortitionNumber'
				>
					<v-text-field
						v-model='sortition.periodicSortitionNumber'
						label='Periodic Sortition Number'
						name='periodicSortitionNumber'
						:error-messages='errors'
						type='number'
					/>
				</validation-provider>
				<h4>Results</h4>
				<validation-provider
					v-slot='{ errors }'
					:value='sortition.resultFields'
					slim
					name='resultFields'
				>
					<v-checkbox
						:error-messages='errors'
						v-for='fillableInput in params.resultFields'
						:key='`fillable-input-${fillableInput.id}`'
						dense
						hide-details
						:label='fillableInput.description'
						v-model='sortition.resultFields'
						:value='fillableInput.id'
					>
					</v-checkbox>
					<v-messages color='red' :value='errors'></v-messages>
				</validation-provider>
			</v-col>
		</v-row>
		<input type='submit' hidden />
	</v-form>
</template>

<script>
import { ValidationProvider, extend } from 'vee-validate';
import SortitionWeekdayScheduleRow from './SortitionWeekdayScheduleRow.vue';
import ResultField from '../../../enumerations/ResultField.json';
import { required } from 'vee-validate/dist/rules.js';

extend('required', {
	...required,
	message: 'This field is required'
});

export default {
	name: 'SortitionForm',
	components: {
		ValidationProvider,
		SortitionWeekdayScheduleRow
	},
	model: {
		prop: 'sortition'
	},
	props: {
		sortition: {
			type: Object,
			required: false,
			default: () => ({}),
			description: 'The sortition to be manipulated.'
		},
		params: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			ResultField
		};
	},
	computed: {
		weekdayIdToWeekdayMap() {
			return Object.fromEntries(this.params.weekdays.map((w) => [w.id, w]));
		}
	},
	methods: {
		onScheduleCopy(payload) {
			const time = payload.time;

			this.sortition.schedules.forEach((schedule) => {
				this.$set(schedule, 'time', time);
			});
		}
	}
};
</script>

<style scoped></style>
